import { Body1 } from 'components/Typography';
import { Button } from '@dapp/multi-lib/sdaoui/Button';
import { useToast } from '@dapp/multi-lib/ui/toast';
import React, { useContext, useEffect } from 'react';
import { AuthContext } from 'structure/providers/AuthProvider';
import { useTranslation } from 'react-i18next';
import { queryKeys } from 'structure/pv2/vault/configs/queryKeys';
import { useQueryClient } from '@tanstack/react-query';

export const VaultCardConnectWallet = () => {
  const { verified, verifyUser, verifyLoading, verifyError } =
    useContext(AuthContext);
  const { t } = useTranslation('vault');
  const queryClient = useQueryClient();
  const toast = useToast();

  useEffect(() => {
    if (!verifyError) return;

    const messages = {
      network: {
        title: t('TOAST.NETWORK_UNAVAILABLE_TITLE'),
        description: t('TOAST.NETWORK_UNAVAILABLE_DESC'),
      },
      cors: {
        title: t('TOAST.CORS_BLOCKED_TITLE'),
        description: t('TOAST.CORS_BLOCKED_DESC'),
      },
      unknown: {
        title: t('TOAST.VERIFY_UNKNOWN_ERROR_TITLE'),
        description: t('TOAST.VERIFY_UNKNOWN_ERROR_DESC'),
      },
    };

    toast({
      title: messages[verifyError].title,
      description: messages[verifyError].description,
      type: 'error',
    });
  }, [toast, t, verifyError]);

  if (verified) return null;

  const handleVerityUser = async () => {
    await verifyUser();
    setTimeout(() => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.vaultScope,
      });
    }, 1000);
  };

  return (
    <div className='flex h-full min-w-[291px] flex-col items-center justify-center gap-6'>
      <Body1 className='text-center'>{t('SIGN_MESSAGE_LABEL')}</Body1>
      <Button size='small' loading={verifyLoading} onClick={handleVerityUser}>
        {t('SING_MESSAGE_BUTTON')}
      </Button>
    </div>
  );
};
